import React from "react";
import Slide from 'react-reveal/Slide';
import Flip from 'react-reveal/Flip';
import Zoom from 'react-reveal/Zoom';


const Resume = ({ data }) => {
  if (data) {
    var skillmessage = data.skillmessage;
    var education = data.education.map(function (education) {
      return (
        <div key={education.school}>
          <h3>{education.school}</h3>
          <p className="info">
            {education.degree} <span>&bull;</span>
            <em className="date">{education.graduated}</em>
          </p>
          <p>{education.description}</p>
        </div>
      );
    });
    
    var skills = data.skills.map(function (skills) {
      var className = "bar-expand " + skills.name.toLowerCase();
      return (
        <li key={skills.name}>
          <Slide left>
            <span style={{ width: skills.level }} className={className}></span>
          </Slide>
          <em>{skills.name}</em>
        </li>
      );
    });
  }

  return (
    <section id="resume">
      <Flip left>
      <div className="row education">
        <div className="three columns header-col">
            <h1>
              <span>Education</span>
            </h1>
        </div>

        <div className="nine columns main-col">
          <div className="row item">
            <div className="twelve columns">{education}</div>
          </div>
        </div>
      </div>
          </Flip>

        
      <div className="row skill">
        <div className="three columns header-col">
          <h1>
            <span>Skills</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <p>{skillmessage}</p>

          <div className="bars">
            <ul className="skills">{skills}</ul>
          </div>
        </div>
      </div>


      

        
      <div className="row skill">
        <div className="three columns header-col">
          <h1>
            <span>Tool I Know</span>
          </h1>
        </div>

        <div class="grid-container grid-container--fill">
          <div class="grid-element">
            <Zoom bottom>
              <img src="./images/tools/0.png"/>
            </Zoom>
          </div>
          <div class="grid-element">
            <Zoom bottom>
              <img src="./images/tools/1.png"/>
            </Zoom>
          </div>
          <div class="grid-element">
            <Zoom bottom>
              <img src="./images/tools/2.png"/>
            </Zoom>
          </div>
          <div class="grid-element">
            <Zoom bottom>
              <img src="./images/tools/3.png"/>
            </Zoom>
          </div>
          <div class="grid-element">
            <Zoom bottom>
              <img src="./images/tools/4.png"/>
            </Zoom>
          </div>
          <div class="grid-element">
            <Zoom bottom>
              <img src="./images/tools/5.svg"/>
            </Zoom>
          </div>
          <div class="grid-element">
            <Zoom bottom>
              <img src="./images/tools/6.png"/>
            </Zoom>
          </div>
          <div class="grid-element">
            <Zoom bottom>
              <img src="./images/tools/7.png"/>
            </Zoom>
          </div>
          <div class="grid-element">
            <Zoom bottom>
              <img src="./images/tools/8.png"/>
            </Zoom>
          </div>
          <div class="grid-element">
            <Zoom bottom>
              <img src="./images/tools/9.jpg"/>
            </Zoom>
          </div>
          <div class="grid-element">
            <Zoom bottom>
              <img src="./images/tools/10.png"/>
            </Zoom>
          </div>
        </div>
      </div>



      
    </section>
  );
};

export default Resume;
